module.exports = __webpack_public_path__ + "img/instagram-icon.a9012cc4.svg";